<template>
    <div v-if="!dataLoading">
        <b-row>
            <div class="col-12">
                <b-form-group :label="$t('name')">
                    <b-form-input :value="form.name" disabled></b-form-input>
                </b-form-group>
            </div>
            <div class="col-12 mt-2">
                <b-form-group :label="$t('number_of_chairs')">
                    <b-form-input :value="form.number_of_chairs" disabled></b-form-input>
                </b-form-group>
            </div>
            <div class="col-12 mt-2">
                <b-form-group :label="$t('explanation')">
                    <b-form-textarea :value="form.explanation" disabled rows="3"></b-form-textarea>
                </b-form-group>
            </div>
            <div class="col-12 mt-2">
                <b-form-group :label="$t('status')">
                    <b-form-input :value="form.status === 'a' ? $t('active') : $t('passive')" disabled></b-form-input>
                </b-form-group>
            </div>
            <div class="col-12 mt-2">
                <b-form-group :label="$t('device_id')">
                    <b-form-textarea :value="form.device_id" disabled rows="3"></b-form-textarea>
                </b-form-group>
            </div>
        </b-row>
    </div>
</template>

<script>
    import LibraryRoomService from "@/services/LibraryRoomService";

    export default {
        props: {
            formId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                dataLoading: true,
                form: {}
            }
        },
        created() {
            this.loadData();
        },
        methods: {
            loadData() {
                LibraryRoomService.get(this.formId)
                    .then(response => {
                        this.form = response.data.data;
                    })
                    .finally(() => {
                        this.dataLoading = false;
                    });
            }
        }
    }
</script>
